import { usePagination, useQueryParams } from '@/hooks';
import { useEffect } from 'react';

export const useReturnsIntakePagination = () => {
  const { setQueryParams, getQueryParam } = useQueryParams();
  const { currentPage, pageSize, handlePageChange, handlePageSizeChange } =
    usePagination({
      initialPage: Number(getQueryParam('page')) || 1,
      initialPageSize: Number(getQueryParam('pageSize')) || 10,
    });

  useEffect(() => {
    setQueryParams({ page: String(currentPage), pageSize: String(pageSize) });
  }, [currentPage, pageSize, setQueryParams]);

  return { currentPage, pageSize, handlePageChange, handlePageSizeChange };
};

export default useReturnsIntakePagination;
